<template
  ><div>
    <div v-if="!isShowDetal">
      <Row :gutter="16">
        <Col :md="12" :xs="24">
          <Card>
            <p slot="title">
              <Icon
                type="md-people"
                size="22"
                style="margin-right:10px"
              /><!-- 团队 -->{{ $t("PB_Team") }}
            </p>
            <div class="cs-tabPane1-teamBox">
              <Row>
                <Col
                  :md="12"
                  :xs="24"
                  v-for="(item, index) in infoLIst"
                  :key="index"
                >
                  <div @click="getDetail(item)" class="cs-tabPane1-teamItem">
                    <img
                      class="cs-tabPane1-teamItem-teamImg"
                      v-if="item.portrait"
                      :src="'data:image/jpeg;base64,' + item.portrait || ''"
                    />
                    <img
                      class="cs-tabPane1-teamItem-teamImg"
                      v-else
                      src="@/assets/headerImg.png"
                    />
                    <!-- <span class="cs-tabPane1-teamItem-teamImg" style="display: flex; align-items: center;border: 1px solid #eeeeee;border-radius:10px" v-else>暂无图片</span> -->
                    <div class="cs-tabPane1-teamItem-teamContent">
                      <div>
                        <p style="font-wigth:blod">
                          {{ lang == "zh" ? item.userName : item.userEName }}
                        </p>
                        <!-- <p style="font-size:14px;color:#666666">{{ item.eName }}</p> -->
                      </div>
                      <!-- {{ lang=='zh'?item.businessUnit:item.enBusinessUnit }} -->
                      <p>
                        {{ lang == "zh" ? item.position : item.enPosition }}
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
          </Card>
        </Col>
        <Col :md="12" :xs="24">
          <Form
            :model="formItem"
            :disabled="id != '' || empLoyeeDisabled == '1'"
          >
            <FormItem :label="$t('Team_Strength_&_Diversity')"
              ><!-- 团队优势，多样性 -->
              <Input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 20 }"
                v-model="formItem.teamAdvantage"
              />
            </FormItem>
            <FormItem :label="$t('Team_Performance')"
              ><!-- 团队绩效 -->
              <Input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 20 }"
                v-model="formItem.teamPerformance"
              />
            </FormItem>
            <FormItem :label="$t('Vacancy')"
              ><!-- 空缺 -->
              <Input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 20 }"
                v-model="formItem.teamVacancy"
              />
            </FormItem>
            <FormItem :label="$t('People_ready_to_next_move_within_6_months')"
              ><!-- 6个月内可能发生变动的人员 -->
              <Input
                type="textarea"
                :autosize="{ minRows: 3, maxRows: 20 }"
                v-model="formItem.changedPersonnel"
              />
            </FormItem>
          </Form>
        </Col>
      </Row>
      <Row :gutter="16">
        <Col span="24">
          <Form :model="formItem">
            <FormItem :label="$t('PB_Comment')" v-if="id != ''"
              ><!-- 备注说明 -->
              <Input
                type="textarea"
                :autosize="{ minRows: 5, maxRows: 20 }"
                v-model="formItem.comment"
              />
            </FormItem>
          </Form>
        </Col>
      </Row>
      <div class="btnRight" style="padding-top:40px">
        <Button
          type="primary"
          class="btn"
          @click="save"
          :disabled="beEnd == 1 || beEnd == 4 || empLoyeeDisabled == '1'"
          ><!-- 保存 -->{{ $t("Save") }}</Button
        >
      </div>
    </div>
    <Spin size="large" fix v-if="spinShow"></Spin>
    <j2-talentCard
      ref="talentCard"
      v-if="isShowDetal"
      @back="isShowDetal = false"
    ></j2-talentCard>
    <!-- <tabPane1DetalVue ref="tabPane1DetalVue" v-show="isShowDetal" @back="isShowDetal = false" /> -->
  </div>
</template>
<script>
import tabPane1DetalVue from "./tabPane1Detal.vue";
import axios from "axios";
export default {
  components: {
    tabPane1DetalVue
  },
  data() {
    return {
      spinShow: false,
      isShowDetal: false,
      infoLIst: [],
      formItem: {},
      id: "",
      serialnumber: "",
      // 员工档案团队情况进入不可编辑
      empLoyeeDisabled: "",
      saveId: "",
      btnShow: true,
      beTopLevel: "",
      indexId: "",
      beEnd: ""
    };
  },
  computed: {
    lang() {
      return this.$store.getters.selectLangeData;
    }
  },
  mounted() {
    if (this.getQueryVariable("empFlag")) {
      let obj = {
        serialnumber: this.getQueryVariable("id")
      };
      this.getDetail(obj);
    }
    // this.getData()
  },
  methods: {
    getData() {
      this.spinShow = true;
      axios
        .post("/teamInfo/selectTeamInfo", {
          talentInventoryId: this.id,
          serialnumber: this.serialnumber,
          pagename:this.getQueryVariable("pagename")
        })
        .then(res => {
          this.spinShow = false;
          if (res) {
            this.infoLIst = res.employeeList;
            res.id ? (this.saveId = res.id) : "";
            this.formItem = res;
            this.beEnd = res.beEnd;
          }
        });
    },
    getDetail(item) {
      this.isShowDetal = true;
      this.$nextTick(() => {
        this.$refs.talentCard.getData(item.serialnumber);
        this.$refs.talentCard.btnShow = this.btnShow;
      });
    },
    save() {
      this.spinShow = true;
      axios
        .post("/teamInfo/saveTeamInfo", {
          id: this.saveId,
          serialnumber: this.serialnumber,
          ...this.formItem,
          talentInventoryId: this.id
        })
        .then(res => {
          this.spinShow = false;
          if (res) {
            this.infoLIst = res.employeeList;
            this.getData();
            this.$Message.success(res);
          }
        });
    },
    getQueryVariable(variable) {
      var query = window.location.search.substring(1);
      var vars = query.split("&");
      for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split("=");
        if (pair[0] == variable) {
          return pair[1];
        }
      }
      return false;
    }
  }
};
</script>
<style lang="less" scoped>
.cs-tabPane1-teamBox {
  height: 420px;
  padding: 0 10px;
  overflow: auto;
}
.cs-tabPane1-teamItem {
  display: flex;
  justify-content: space-between;
  height: 80px;
  padding-left: 10px;
  margin-bottom: 20px;
  cursor: pointer;
}
.cs-tabPane1-teamItem-teamImg {
  width: 70px;
  max-height: 100%;
  margin-right: 20px;
  border-radius: 50%;
}
.cs-tabPane1-teamItem-teamContent {
  flex: 3;
  height: 100%;
  border: 1px solid #eee;
  padding: 10px 20px;
  border-radius: 15px;
}
::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
}
::-webkit-scrollbar-thumb {
  /*滚动条里面小方块*/
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(97, 184, 179, 0.1);
  background: #4ea397;
}
::-webkit-scrollbar-track {
  /*滚动条里面轨道*/
  box-shadow: inset 0 0 5px rgba(87, 175, 187, 0.1);
  border-radius: 10px;
  background: #ededed;
}
</style>



// WEBPACK FOOTER //
// src/components/process/MyQuery/teamInfoComponents/tabPane1.vue